module.exports = __webpack_public_path__ + "media/mypage/images/top5-f931d421a3cba521f468432f85029176.jpg";